/* tslint:disable */
/* eslint-disable */
/**
 * settingManage API
 * 設定管理APIの定義
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * ダッシュボードアラート設定
 * @export
 * @interface ApiDashboardAlertSetting
 */
export interface ApiDashboardAlertSetting {
    /**
     * 
     * @type {ApiDashboardAlertSettingSeverity}
     * @memberof ApiDashboardAlertSetting
     */
    'critical': ApiDashboardAlertSettingSeverity;
    /**
     * 
     * @type {ApiDashboardAlertSettingSeverity}
     * @memberof ApiDashboardAlertSetting
     */
    'warning': ApiDashboardAlertSettingSeverity;
}
/**
 * 重要度ごとのアラート設定
 * @export
 * @interface ApiDashboardAlertSettingSeverity
 */
export interface ApiDashboardAlertSettingSeverity {
    /**
     * 
     * @type {ApiDashboardAlertSettingThresholds}
     * @memberof ApiDashboardAlertSettingSeverity
     */
    'excess': ApiDashboardAlertSettingThresholds;
    /**
     * 
     * @type {ApiDashboardAlertSettingThresholds}
     * @memberof ApiDashboardAlertSettingSeverity
     */
    'shortage': ApiDashboardAlertSettingThresholds;
}
/**
 * アラート判定に使用する設定値
 * @export
 * @interface ApiDashboardAlertSettingThresholds
 */
export interface ApiDashboardAlertSettingThresholds {
    /**
     * 判定対象とする連続月数
     * @type {string}
     * @memberof ApiDashboardAlertSettingThresholds
     */
    'consecutiveMonths': string;
    /**
     * 内示正答率の閾値
     * @type {string}
     * @memberof ApiDashboardAlertSettingThresholds
     */
    'ratioThreshold': string;
    /**
     * 前月比の閾値
     * @type {string}
     * @memberof ApiDashboardAlertSettingThresholds
     */
    'momChangeRateThreshold': string;
    /**
     * 最小検知数量の閾値
     * @type {string}
     * @memberof ApiDashboardAlertSettingThresholds
     */
    'minQuantityThreshold': string;
}
/**
 * エラーレスポンス
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponse
     */
    'headers': string;
    /**
     * 
     * @type {ErrorResponseBody}
     * @memberof ErrorResponse
     */
    'body': ErrorResponseBody;
}
/**
 * 
 * @export
 * @interface ErrorResponseBody
 */
export interface ErrorResponseBody {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseBody
     */
    'statusCode': number;
    /**
     * 
     * @type {ErrorResponseCode}
     * @memberof ErrorResponseBody
     */
    'code': ErrorResponseCode;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseBody
     */
    'message': string;
}


/**
 * エラー時のレスポンスコード backendのcommon_layer/return_code.py参照
 * @export
 * @enum {string}
 */

export const ErrorResponseCode = {
    BadRequest: 'BAD_REQUEST',
    NotRegisteredBusiness: 'NOT_REGISTERED_BUSINESS',
    FkConstraintFailed: 'FK_CONSTRAINT_FAILED',
    Unauthorized: 'UNAUTHORIZED',
    Forbidden: 'FORBIDDEN',
    NotFound: 'NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    UpdateTimingConflict: 'UPDATE_TIMING_CONFLICT',
    InternalServerError: 'INTERNAL_SERVER_ERROR'
} as const;

export type ErrorResponseCode = typeof ErrorResponseCode[keyof typeof ErrorResponseCode];


/**
 * 
 * @export
 * @interface GetDashboardAlertSettingSuccessResponseResult
 */
export interface GetDashboardAlertSettingSuccessResponseResult {
    /**
     * 
     * @type {number}
     * @memberof GetDashboardAlertSettingSuccessResponseResult
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof GetDashboardAlertSettingSuccessResponseResult
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof GetDashboardAlertSettingSuccessResponseResult
     */
    'message': string;
    /**
     * 
     * @type {ApiDashboardAlertSetting}
     * @memberof GetDashboardAlertSettingSuccessResponseResult
     */
    'result': ApiDashboardAlertSetting;
}
/**
 * 成功レスポンス
 * @export
 * @interface SuccessResponse
 */
export interface SuccessResponse {
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'statusCode': number;
    /**
     * 
     * @type {number}
     * @memberof SuccessResponse
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof SuccessResponse
     */
    'message': string;
    /**
     * 
     * @type {object}
     * @memberof SuccessResponse
     */
    'result': object;
}

/**
 * DashboardAlertApi - axios parameter creator
 * @export
 */
export const DashboardAlertApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ダッシュボードアラートの設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/setting/dashboard-alert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ダッシュボードアラートの設定を変更する
         * @param {ApiDashboardAlertSetting} apiDashboardAlertSetting 変更する設定情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put: async (apiDashboardAlertSetting: ApiDashboardAlertSetting, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apiDashboardAlertSetting' is not null or undefined
            assertParamExists('put', 'apiDashboardAlertSetting', apiDashboardAlertSetting)
            const localVarPath = `/setting/dashboard-alert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(apiDashboardAlertSetting, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DashboardAlertApi - functional programming interface
 * @export
 */
export const DashboardAlertApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DashboardAlertApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary ダッシュボードアラートの設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDashboardAlertSettingSuccessResponseResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAlertApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary ダッシュボードアラートの設定を変更する
         * @param {ApiDashboardAlertSetting} apiDashboardAlertSetting 変更する設定情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async put(apiDashboardAlertSetting: ApiDashboardAlertSetting, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.put(apiDashboardAlertSetting, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DashboardAlertApi.put']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DashboardAlertApi - factory interface
 * @export
 */
export const DashboardAlertApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DashboardAlertApiFp(configuration)
    return {
        /**
         * 
         * @summary ダッシュボードアラートの設定を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(options?: any): AxiosPromise<GetDashboardAlertSettingSuccessResponseResult> {
            return localVarFp.get(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ダッシュボードアラートの設定を変更する
         * @param {ApiDashboardAlertSetting} apiDashboardAlertSetting 変更する設定情報
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        put(apiDashboardAlertSetting: ApiDashboardAlertSetting, options?: any): AxiosPromise<SuccessResponse> {
            return localVarFp.put(apiDashboardAlertSetting, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DashboardAlertApi - object-oriented interface
 * @export
 * @class DashboardAlertApi
 * @extends {BaseAPI}
 */
export class DashboardAlertApi extends BaseAPI {
    /**
     * 
     * @summary ダッシュボードアラートの設定を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAlertApi
     */
    public get(options?: RawAxiosRequestConfig) {
        return DashboardAlertApiFp(this.configuration).get(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ダッシュボードアラートの設定を変更する
     * @param {ApiDashboardAlertSetting} apiDashboardAlertSetting 変更する設定情報
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardAlertApi
     */
    public put(apiDashboardAlertSetting: ApiDashboardAlertSetting, options?: RawAxiosRequestConfig) {
        return DashboardAlertApiFp(this.configuration).put(apiDashboardAlertSetting, options).then((request) => request(this.axios, this.basePath));
    }
}



